function i(e, n, t, r = { passive: !0 }) {
  return e.addEventListener(n, t, r), () => e.removeEventListener(n, t);
}
export {
  i as addDomEvent
};
